import { render, staticRenderFns } from "./ServiceExpenses.vue?vue&type=template&id=5680f0e1"
import script from "./ServiceExpenses.vue?vue&type=script&lang=js"
export * from "./ServiceExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports